var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUserImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 253,
    viewBox: "0 0 252 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.937 252.32C195.451 252.32 251.804 195.967 251.804 126.453C251.804 56.9388 195.451 0.586426 125.937 0.586426C56.4227 0.586426 0.0703125 56.9388 0.0703125 126.453C0.0703125 195.967 56.4227 252.32 125.937 252.32Z",
    fill: "#005aaa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7127 220.853C56.7127 213.902 62.3479 208.267 69.2993 208.267H180.87C187.821 208.267 193.457 213.902 193.457 220.853V223.495C193.457 247.403 56.7127 247.403 56.7127 223.495V220.853Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0277 99.027C69.0277 68.99 93.3775 44.6401 123.415 44.6401C153.452 44.6401 177.801 68.9899 177.801 99.0269V114.074C179.746 113.387 181.838 113.013 184.017 113.013C194.316 113.013 202.664 121.361 202.664 131.66C202.664 141.958 194.316 150.307 184.017 150.307C181.795 150.307 179.663 149.918 177.687 149.205C176.179 172.534 159.962 191.856 138.216 197.993V229.788C138.216 236.653 132.65 242.22 125.784 242.22C118.919 242.22 113.353 236.654 113.353 229.789V199.102C89.5198 194.644 71.1609 174.642 69.2011 150.019C68.136 150.208 67.0397 150.307 65.9204 150.307C55.6219 150.307 47.2734 141.958 47.2734 131.66C47.2734 121.361 55.6219 113.013 65.9204 113.013C66.9791 113.013 68.0172 113.101 69.0277 113.271V99.027Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.937 6.87939C191.975 6.87939 245.51 60.4143 245.511 126.453C245.511 192.491 191.975 246.027 125.937 246.027C59.8982 246.027 6.36328 192.491 6.36328 126.453C6.36353 60.4145 59.8984 6.87964 125.937 6.87939Z",
    stroke: "#005aaa",
    strokeWidth: 12.5867
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserImg);
export default __webpack_public_path__ + "static/media/default_user_img.7876eb8df27c119d4a0b4e7967419311.svg";
export { ForwardRef as ReactComponent };